import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import upArrow from '../shared/images/up.svg';
import downArrow from '../shared/images/down.svg';
import upArrowWhite from '../shared/images/up_white.svg';
import downArrowWhite from '../shared/images/down_white.svg';
import { isMobileDevice } from '../helpers/Utils';
import {
  Header, SideBar, Loader, Filter,
} from './common';
import StyleConstants from '../shared/constants/styleConstants/styles.json';
import ScoreDistributionGraph from './scoreDistributionGraph';
import { SIDE_BAR_ITEMS } from '../shared/constants/fieldTypes';
import { getTestOverviewData, enableLoader } from '../actions';

const IS_MOBILE = isMobileDevice();

class Highlights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
    };
    this.updateResults = this.updateResults.bind(this);
  }

  componentDidMount() {
    const { id } = this.state;
    const { getTestOverviewData } = this.props;
    const payload = {
      id,
    };
    getTestOverviewData(payload);
    window.addEventListener('resize', this.resize);
  }

  updateResults(payload) {
    const { getTestOverviewData, enableLoader } = this.props;
    const { id } = this.state;
    if (payload.id !== id) {
      window.location.href = `/highlights/${payload.id}`;
    } else {
      enableLoader();
      getTestOverviewData(payload);
    }
  }

  renderScores() {
    const { rank, medianData, attendancePercentage } = this.props;
    const distributionData = IS_MOBILE ? Object.keys(rank) : medianData;
    const colors = ['#6C5CE7', '#3B82F6', '#F59E0B', '#10B981'];
    return (
      <div style={{ padding: IS_MOBILE ? '16px 20px' : '0', marginBottom: 24 }}>
        <div style={{
          fontSize: 13, fontWeight: 600, color: '#8B8FA3', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 14,
        }}>
          Median Scores
        </div>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          {distributionData && distributionData.map((type, index) => {
            const accentColor = colors[index % colors.length];
            return (
              <div
                key={IS_MOBILE ? type : type.label}
                style={{
                  flex: '1 1 0', minWidth: 120, maxWidth: 220, background: '#FFFFFF', borderRadius: 12, padding: '20px 16px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #F0F0F5',
                  textAlign: 'center', display: (IS_MOBILE && type === 'Lowest Score') ? 'none' : 'flex',
                  flexDirection: 'column', alignItems: 'center', position: 'relative', overflow: 'hidden',
                }}
              >
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: accentColor,
                }} />
                <div style={{
                  fontSize: 28, fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2, marginTop: 4,
                }}>
                  {IS_MOBILE ? rank[type] || 0 : `${type.value}/${type.score}` || 0}
                </div>
                <div style={{
                  fontSize: 12, fontWeight: 500, color: '#8B8FA3', marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.3px',
                }}>
                  {IS_MOBILE ? type : type.label}
                </div>
              </div>
            );
          })}
          {IS_MOBILE && (
            <div style={{
              flex: '1 1 0', minWidth: 120, background: '#FFFFFF', borderRadius: 12, padding: '20px 16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #F0F0F5',
              textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center',
            }}>
              <div style={{ fontSize: 28, fontWeight: 700, color: '#1a1a2e' }}>
                {attendancePercentage || 0}%
              </div>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#8B8FA3', marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                Attendance
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderPerformanceShift() {
    const { studentsPerformanceChange } = this.props;
    const improved = Object.keys(studentsPerformanceChange.increased || {}).length || 0;
    const dropped = Object.keys(studentsPerformanceChange.decreased || {}).length || 0;
    return (
      <div style={{ marginBottom: 24 }}>
        <div style={{
          fontSize: 13, fontWeight: 600, color: '#8B8FA3', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 14,
        }}>
          Performance Shifts
        </div>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          <div style={{
            flex: 1, minWidth: 200, background: IS_MOBILE ? '#00C674' : '#FFFFFF', borderRadius: 12, padding: '24px 20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: IS_MOBILE ? 'none' : '1px solid #F0F0F5',
            display: 'flex', alignItems: 'center', gap: 16,
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: IS_MOBILE ? 'rgba(255,255,255,0.2)' : '#ECFDF5',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <img src={IS_MOBILE ? upArrowWhite : upArrow} alt="" width={20} height={20} />
            </div>
            <div>
              <div style={{
                fontSize: 28, fontWeight: 700, color: IS_MOBILE ? '#FFFFFF' : '#00C674', lineHeight: 1.1,
              }}>
                {improved}
                <span style={{ fontSize: 16, fontWeight: 500, marginLeft: 4 }}>Students</span>
              </div>
              <div style={{
                fontSize: 12, fontWeight: 500, color: IS_MOBILE ? 'rgba(255,255,255,0.8)' : '#8B8FA3', marginTop: 2,
              }}>
                Significantly improved
              </div>
            </div>
          </div>
          <div style={{
            flex: 1, minWidth: 200, background: IS_MOBILE ? StyleConstants.color.error : '#FFFFFF', borderRadius: 12, padding: '24px 20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: IS_MOBILE ? 'none' : '1px solid #F0F0F5',
            display: 'flex', alignItems: 'center', gap: 16,
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: IS_MOBILE ? 'rgba(255,255,255,0.2)' : '#FEF2F2',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <img src={IS_MOBILE ? downArrowWhite : downArrow} alt="" width={20} height={20} />
            </div>
            <div>
              <div style={{
                fontSize: 28, fontWeight: 700, color: IS_MOBILE ? '#FFFFFF' : StyleConstants.color.error, lineHeight: 1.1,
              }}>
                {dropped}
                <span style={{ fontSize: 16, fontWeight: 500, marginLeft: 4 }}>Students</span>
              </div>
              <div style={{
                fontSize: 12, fontWeight: 500, color: IS_MOBILE ? 'rgba(255,255,255,0.8)' : '#8B8FA3', marginTop: 2,
              }}>
                Marks dropped sharply
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRankList() {
    const { rankList } = this.props;
    const { id } = this.state;
    return (
      <div style={{ marginBottom: 15 }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 16, fontWeight: 'bold', padding: '0 20px', marginBottom: 10,
        }}>
          <div>Rank List</div>
          <div
            style={{ color: StyleConstants.color.primary, fontSize: 14, cursor: 'pointer' }}
            role="presentation"
            onClick={() => { window.location.href = `/rank_list/${id}`; }}
          >
            More
          </div>
        </div>
        <div>
          {rankList.slice(0, 3).map((data, index) => (
            <div
              key={`rank_${index}`}
              className="Card-View"
              style={{
                margin: '0 20px 5px', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <div style={{
                background: '#EAEAEA', justifyContent: 'center', margin: '6px 15px', height: 33, width: 33, borderRadius: 16, display: 'flex', placeItems: 'center', fontSize: 12,
              }}>
                <div>{index + 1}</div>
              </div>
              <div style={{ textOverflow: 'ellipsis', fontSize: 14 }}>{data.name}</div>
              <div style={{ marginLeft: 'auto', marginRight: 15, fontSize: 12 }}>{data.overall_total}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderScoreGraph() {
    const { id } = this.state;
    const { scoreDistribution } = this.props;
    return (
      <div style={{ marginBottom: 24 }}>
        <div style={{
          fontSize: 13, fontWeight: 600, color: '#8B8FA3', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 14,
        }}>
          Score Distribution
        </div>
        <div style={{
          background: '#FFFFFF', borderRadius: 12, padding: IS_MOBILE ? '0 0 20px' : 24,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #F0F0F5',
        }}>
          {IS_MOBILE && (
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 0',
            }}>
              <div style={{ fontSize: 16, fontWeight: 'bold' }}>Score Distribution</div>
              <div
                style={{ color: StyleConstants.color.primary, fontSize: 14, cursor: 'pointer' }}
                role="presentation"
                onClick={() => { window.location.href = `/test_score_distribution/${id}`; }}
              >
                More
              </div>
            </div>
          )}
          {Object.keys(scoreDistribution.graph_scores).length > 0
            && <ScoreDistributionGraph />}
        </div>
      </div>
    );
  }

  render() {
    const { id } = this.state;
    const { showLoader } = this.props;
    const {
      studentsPerformanceChange, isFilter, rankList,
    } = this.props;
    if (showLoader) {
      return <Loader />;
    }
    if (isFilter) {
      return (
        <div>
          <Header testId={id} updateResults={this.updateResults} menuData={SIDE_BAR_ITEMS.HIGHLIGHTS} />
          <Filter updateResults={this.updateResults} menuData={SIDE_BAR_ITEMS.HIGHLIGHTS} testId={id} />
        </div>
      );
    }
    return (
      <div style={{ userSelect: 'none' }}>
        <div className="row" style={{ backgroundColor: '#F7F8FC', marginBottom: 67 }}>
          <div style={{
            width: IS_MOBILE ? '75%' : '20%', padding: 0, zIndex: 1, marginTop: IS_MOBILE ? 60 : StyleConstants.headerHeight.web,
          }}>
            <SideBar menuList={SIDE_BAR_ITEMS} selectedOption="HIGHLIGHTS" testId={id} />
          </div>
          <div style={{
            width: !IS_MOBILE ? '80%' : '100%', paddingLeft: 0, paddingRight: 0, zIndex: 0, marginTop: IS_MOBILE ? 0 : StyleConstants.headerHeight.web,
          }}>
            <Header testId={id} updateResults={this.updateResults} menuData={SIDE_BAR_ITEMS.HIGHLIGHTS} />
            <div style={{ padding: IS_MOBILE ? 0 : '28px 40px' }}>
              {this.renderScores()}
              <div>
                {(studentsPerformanceChange.increased && studentsPerformanceChange.decreased
                  && (Object.keys(studentsPerformanceChange.increased).length > 0
                    || Object.keys(studentsPerformanceChange.decreased).length > 0))
                  && this.renderPerformanceShift()}
                {IS_MOBILE && rankList.length > 0 && this.renderRankList()}
              </div>
              {this.renderScoreGraph()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Highlights.propTypes = {
  attendancePercentage: PropTypes.number,
  scoreDistribution: PropTypes.object,
  rankList: PropTypes.array,
  rank: PropTypes.object,
  studentsPerformanceChange: PropTypes.array,
  medianData: PropTypes.object,
  isFilter: PropTypes.bool,
  match: PropTypes.object,
  params: PropTypes.object,
  getTestOverviewData: PropTypes.func.isRequired,
  showLoader: PropTypes.bool,
  enableLoader: PropTypes.func.isRequired,
};

Highlights.defaultProps = {
  attendancePercentage: 0,
  scoreDistribution: {},
  rankList: [],
  rank: {},
  studentsPerformanceChange: [],
  medianData: {},
  isFilter: false,
  match: {},
  params: {},
  showLoader: false,
};


const mapStateToProps = ({ insight }) => ({
  attendancePercentage: insight.attendancePercentage,
  scoreDistribution: insight.scoreDistribution,
  rankList: insight.rankList,
  rank: insight.rank,
  studentsPerformanceChange: insight.studentsPerformanceChange,
  medianData: insight.medianData,
  isFilter: insight.isFilter,
  showLoader: insight.showLoader,
});

export default connect(mapStateToProps, { getTestOverviewData, enableLoader })(Highlights);
